<template>
<div class="chapter">
<div class="inner_page">
<p class="C1608"><span id="page_3">Part </span>1</p>
<p class="C1609">From Our House to Your House</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_1__From.vue?623db010